class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.announcementBarPadding();
  }

  announcementBarPadding() {
    const mobileMediaQuery = window.matchMedia('(max-width:' + window.mediaStrings.mobile + ')');
    let linklistWidth = 0;
    if(document.querySelector('.announcement-bar__linklist')){
      linklistWidth = document.querySelector('.announcement-bar__linklist').offsetWidth;
    }
    
    if (linklistWidth && !mobileMediaQuery.matches) {
      let padding = Math.ceil(linklistWidth+20);
      this.querySelector('.announcement-bar').style.paddingLeft = padding + 'px'
    }
    
  }

}

customElements.define('announcement-bar', AnnouncementBar);

class AnnouncementBarClose extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const announcementBar = this.closest('announcement-bar');
      announcementBar.style.display = 'none';
    });
  }
}

customElements.define('announcement-bar-close', AnnouncementBarClose);